// re-export the namespaces from vivaa-api, for access to types
import { Client, Environment } from 'vivaa-api';
export * from 'vivaa-api';

export const client = new Client(
  document.location.hostname === 'localhost' ||
  document.location.hostname === '127.0.0.1'
    ? undefined
    : Environment.Webprod,
);
